import React from "react";
//import { useEffect, useRef } from "react";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Container, Row, Col, Button } from "react-bootstrap";
import Splash1 from "../images/splash-1-2025.jpg";
import SplashMarsh from "../images/snow-branches.jpg";

function Splash() {
  const scrollBy = window.innerHeight;
  //console.log("SPLASH:", window.innerHeight);
  //used for button
  const scrollToSection = () => {
    const targetSection = document.getElementById("targetSection");
    if (targetSection) {
      targetSection.scrollIntoView({ behavior: "smooth" });
      // Adjust for the fixed header after the smooth scroll
      const onScroll = () => {
        window.scrollBy(0, scrollBy);
        window.removeEventListener("scroll", onScroll);
      };
      window.addEventListener("scroll", onScroll);
    }
  };

  return (
    <div className='splash-container'>
      <img src={SplashMarsh} alt='Piermont Marsh' className='splash-image' />
      <div className='splash-content'>
        <Container>
          <Row className='d-flex flex-column align-items-center text-center'>
            <Col xs={12}>
              <h2 className='splash-text drop-shadow'>
                Piermont Flywheel Gallery
              </h2>
              <h1 className='splash-text splash-headline mb-4 drop-shadow text-upper'>
                Guest Artist Showcase 2025
              </h1>
              <Button className='btn btn-primary' onClick={scrollToSection}>
                Learn More...
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Splash;
